import { PlusCircleFilled } from "@ant-design/icons";
import { Select } from "antd";
import type { BaseSelectRef } from "rc-select";
import * as React from "react";
import { classNames } from "src/common/classNames";
import { ZSidLabel } from "src/types";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import * as styles from "./SelectFromModalButton.module.less";

type PropsSelectFromModalButton = {
  children?: React.ReactNode; // Предполагается, что сюда можно передать компонент модалки
  disabled?: boolean;
  title?: string;
  options: ZSidLabel[];
  multi?: boolean;
  onChange?(value: ZSidLabel[] | null): void;
  onOpen(): void;
  activateCallback?: ActivateCallback;
  makeTagLabel?(option: ZSidLabel): React.ReactNode; // Кастомизация тегов
  onBlur?(): void;
};

export const SelectFromModalButton: React.FC<PropsSelectFromModalButton> = (
  props,
) => {
  const {
    children,
    disabled,
    title,
    options,
    multi,
    onChange,
    onOpen,
    activateCallback,
    makeTagLabel,
    onBlur,
  } = props;

  const internalChange = (value: string[] | undefined) => {
    // Здесь возможно либо удаление одного значения (для multi) через нажатия на крестик тега.
    // Либо удаление всех значений через allowClear
    let newOptions: ZSidLabel[] | null = null;
    if (value) {
      const valuesSet = new Set(value);
      newOptions = options.filter((op) => valuesSet.has(op.id));
    }
    onChange?.(newOptions);
  };

  const ctrlRef = useActivateCallback<BaseSelectRef>(
    activateCallback,
    (ref) => () => {
      ref?.focus();
    },
  );

  const richOptions: { id: string; label: React.ReactNode }[] = makeTagLabel
    ? options.map((op) => ({
        id: op.id,
        label: makeTagLabel(op),
      }))
    : options;

  return (
    <>
      <Select
        ref={ctrlRef}
        disabled={disabled}
        allowClear
        title={title}
        value={options.map(({ id }) => id)}
        options={richOptions}
        fieldNames={{ value: "id" }}
        mode={multi ? "multiple" : undefined}
        maxTagCount="responsive"
        onOpenChange={(isOpen) => {
          onBlur?.();
          if (isOpen) onOpen();
        }}
        open={false}
        onChange={internalChange}
        suffixIcon={
          <PlusCircleFilled
            className={classNames([
              styles.plusCircleFilled,
              [disabled, styles.disabled],
            ])}
            onClick={() => {
              if (!disabled) onOpen();
            }}
          />
        }
        showSearch={false}
        style={{ width: "100%" }}
      />
      {children}
    </>
  );
};
